import { BACKEND_BASE_URL } from "./backendBaseUrl";
export const PASSWORD_BASE_URL = BACKEND_BASE_URL + "/password";

export const CREATE_PASSWORD = "/";
export const GET_ALL_PASSWORD = "/";
export const SHARE_PASSWORD = "/share";
export const GET_A_PASSWORD = "/vault";
export const GET_ENV_PASSWORDS = "/env";
export const GET_FOLDER_PASSWORDS = "/folder";
export const FORWARD_PASSWORD = "/forward";
export const UPLOAD_CSV = "/csv";
export const GLOBAL_SEARCH = "/globalsearch";
export const PW_DETAILS = "/details";
